export default {
  type: 'stocker-port',
  description: 'Stocker I/O Port',
  group: '3D',
  icon: undefined,
  model: {
    type: 'stocker-port',
    left: 100,
    top: 100,
    width: 40,
    height: 30,
    depth: 20,
    portType: 'in',
    strokeStyle: '#666'
  }
}
